module.exports = __webpack_public_path__ + "media/companies/Banque-Hottinguer-dff10eb2.png";